module.exports = __webpack_public_path__ + "static/media/pricing-11-m.0ad79965.png";